import type { FabMenuOptionId, TabType } from '@hunting-nature/shared-core/enums/tab-bar.enum';
import { createAction, props } from '@ngrx/store';

import { prefixed } from '../../utils/factory.utils';

const action = prefixed('[Tab Bar]');

export const TabBarActions = {
  toggleTabBarMenu: createAction(action('Toggle Tab Bar Menu')),
  openTabBarMenu: createAction(action('Open Tab Bar Menu')),
  closeTabBarMenu: createAction(action('Close Tab Bar Menu')),

  // Generic expanded card – store stays feature-agnostic
  expandOption: createAction(action('Expand Option'), props<{ optionId: FabMenuOptionId }>()),
  collapseOption: createAction(action('Collapse Option')),

  selectTab: createAction(action('Select Tab'), props<{ tab: TabType }>()),
  syncActiveTabFromRoute: createAction(action('Sync active tab from route'), props<{ tab: TabType }>()),
  initTabBar: createAction(action('Init tab bar')),
};
